import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';

import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Note from '../../Note';

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../../images/icons/greenChecked.svg';
import AuthUserContainer from '../../../containers/AuthUser';
import EquipmentAssignmentContainer from '../../../containers/EquipmentAssignment';

function styles() {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle: {
			fontSize: 20,
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
			color: 'white',
			marginRight: 10,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
	};
}

class EndAssignmentDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			isSaving: false,
			savingSuccessful: false,
		};
	}

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};

	submitEndAssignment = () => {
		const { equipmentAssignmentToEnd, endEquipmentAssignment, showErrors } = this.props;

		this.setState({ isSaving: true, savingSuccessful: false });
		const { equipmentAssignmentId } = equipmentAssignmentToEnd;
		const params = {
			equipmentAssignmentId,
		};

		endEquipmentAssignment({
			params,
			callback: (err, r) => {
				if (err) {
					this.setState({ isSaving: false });
					showErrors(err);
					return;
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});

					_.delay(() => {
						this.setState({ savingSuccessful: false });
						window.location.reload();
					}, 500);
				}, 400);
			},
		});
	};

	render() {
		const { open, onClose, equipmentAssignmentToEnd, classes, equipmentMap } = this.props;

		if (!equipmentAssignmentToEnd) {
			return (
				<Dialog open={open} TransitionComponent={Transition} onClose={onClose}>
					<div className={classes.inner}>
						Sorry missing equipmentAssignmentToEnd. Please refresh???
					</div>
				</Dialog>
			);
		}

		const { equipmentId } = equipmentAssignmentToEnd;

		const equipment = equipmentMap[equipmentId] || { display: 'Missing' };
		const equipmentDisplay = `${equipment.display} - (${equipment.geoTabComment})`;

		const { isSaving, savingSuccessful } = this.state;
		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={onClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>
							End assignment for <strong>{equipmentDisplay}</strong>
						</div>
						<div>
							<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<form>
						<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
							<Grid item xs={12}>
								<Note
									label={
										'Typically you would only end a truck assignment when that truck' +
										' is decommissioned or in maintenance for an extended period of time. ' +
										' If the equipment is only moving terminals then you should REASSIGN instead.'
									}
								/>
							</Grid>

							<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
								<Button
									variant="contained"
									color="secondary"
									className={classes.addButton}
									onClick={this.submitEndAssignment}
									disabled={isSaving}
								>
									Yes, End Truck Assignment
								</Button>

								<Button variant="outlined" className={classes.button} onClick={onClose}>
									Cancel
								</Button>

								<Zoom
									in={isSaving}
									style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
									mountOnEnter
									unmountOnExit
								>
									<div className={classes.isSaving}>
										<CircularProgress style={{ verticalAlign: 'middle' }} />
										<span style={{ paddingLeft: 10 }}>Saving...</span>
									</div>
								</Zoom>

								<Zoom
									in={savingSuccessful}
									style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
								>
									<div className={classes.savingSuccessful}>
										<div className={classes.greenCheckedIcon} />
										<span style={{ paddingLeft: 10 }}>Save Successful.</span>
									</div>
								</Zoom>
							</Grid>
						</Grid>
					</form>
				</div>
			</Dialog>
		);
	}
}

EndAssignmentDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	endEquipmentAssignment: PropTypes.func,

	equipmentAssignmentToEnd: PropTypes.object,
	equipmentMap: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	EquipmentAssignmentContainer,
])(EndAssignmentDialog);
